import { InjectionToken } from '@angular/core';

import { CPopTemplateDataElement } from './c-pop-template-data-element.model';
import { CPopTemplateTextElement } from './c-pop-template-text-element.model';

export const CMPS_EC_TEXT_ELEMENT = new InjectionToken<CPopTemplateTextElement>(
    'CMPS_EC_TEXT_ELEMENT',
);

export const CMPS_EC_DATA_ELEMENT = new InjectionToken<CPopTemplateDataElement>(
    'CMPS_EC_DATA_ELEMENT',
);
